export const RQ_GET_FIELD_STRUCTURE_API = {
  url: 'report/filed-structure/<%= divisionId %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_ALL_EMPLOYEE_DETAILS_API = {
  url: 'report/allemployeedetails',
  method: 'GET',
  auth: true,
};

export const RQ_GET_FIELD_STRUCTURE_HIERARCHY_API = {
  url: 'report/field-structure-for-hierarchy',
  method: 'GET',
  auth: true,
};
